module.exports = __webpack_public_path__ + "assets/normal/images/cloud_bg_color.9ea48bd7.png";